import { render, staticRenderFns } from "./invoices-pdf.vue?vue&type=template&id=6981e1b0&scoped=true&"
import script from "./invoices-pdf.vue?vue&type=script&lang=ts&"
export * from "./invoices-pdf.vue?vue&type=script&lang=ts&"
import style0 from "./invoices-pdf.vue?vue&type=style&index=0&id=6981e1b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981e1b0",
  null
  
)

export default component.exports